
import { Component, Vue } from 'vue-property-decorator'
import SSwitch from '@/components/SSwitch'
import ImagePreview from '@/views/goodsManage/commodity/template/ImagePreview.vue'
import coomdsPrice from '@/views/goodsManage/commodity/subPage/coomdsPrice.vue'
import coomdsPrices from '@/views/goodsManage/commodity/subPage/coomdsPrices.vue'
import { goodsPackageDto, goodsSpecificationDto, goodsImageDto, customerLevelDto, customerPriceDto } from '@/api/goods'
import { FileDTO, upFile, fileTypes } from '@/api/commonConfig'
import { downloadUrl, printFn, formatterMoney } from '@/utils/util'
import { Getter } from 'vuex-class'
import { Form } from 'vant'
import { chooseFile } from '@/utils/h5ToApp'

@Component({
  components: {
    SSwitch,
    ImagePreview,
    coomdsPrice: () => import('@/views/goodsManage/commodity/subPage/coomdsPrice.vue'),
    coomdsPrices: () => import('@/views/goodsManage/commodity/subPage/coomdsPrices.vue')
  }
})
export default class GoodsPackage extends Vue {
  @Getter companyId!: string
  downloadUrl = downloadUrl
  formatterMoney = formatterMoney
  $refs!: {
    coomdsPrice,
    coomdsPrices,
    validateForm: Form
  }
  packageIndex = 0
  multiSpec = false
  // 所有上架套餐数量
  upGoodsPackageLength = 0
  labelWidth = '7em'
  visible = false
  goodsSpecsMap = new Map()
  goodsPackageList: goodsPackageDto[] = []
  goodsSpecificationList: goodsSpecificationDto[] = []
  goodsImageList: goodsImageDto[] = []

  get title () {
    return '套餐信息'
  }

  created () {
  }

  /**
   * 非汉字输入
   */
  formatterCode (value) {
    return value.replace(/[\u4e00-\u9fa5]/g, '') // 限制只能输入非汉字内容
  }

  cusLevelPriceList (data: goodsPackageDto) {
    return data.cusLevelPriceList && data.cusLevelPriceList.length
  }

  cusPriceList (data: goodsPackageDto) {
    return data.cusPriceList && data.cusPriceList.length
  }

  handleBack () {
    this.$eventBus.$emit('currentPage', 1)
    this.visible = false
  }

  handleHomeBack () {
    this.$confirmDialog.show({
      okText: '确认',
      cancelText: '取消',
      tips: '现在退出则不会保存已修改内容，是否确认退出?',
      onOk: () => {
        this.$goHomeBack()
      },
    })
  }

  /**
   * 商品套餐信息按客户级别定价界面原生返回功能调用
   */
  handlePriceBack () {
    this.$refs.coomdsPrice.handleBack()
  }

  /**
   * 商品套餐信息按客户定价界面原生返回功能调用
   */
  handlePricesBack () {
    this.$refs.coomdsPrices.handleBack()
  }

  handleSave () {
    this.$refs.validateForm.validate().then(() => {
      this.$emit('on-save', {data: this.goodsPackageList[0], index: this.packageIndex})
      this.handleBack()
    })
  }

  showModal (res: { data: goodsPackageDto, index: number, goodsSpecificationList: goodsSpecificationDto[], multiSpec: boolean, upGoodsPackageLength: number }) {
    this.goodsPackageList = [res.data]
    this.goodsSpecificationList = res.goodsSpecificationList
    this.multiSpec = res.multiSpec
    this.packageIndex = res.index
    this.upGoodsPackageLength = res.upGoodsPackageLength
    this.goodsImageList = [
      {
        imageUrl: this.goodsPackageList[0].mainImageUrl
      }
    ]
    this.goodsPackageList.map(item => {
      item.isSyncOtherBool = Number(item.isSyncOther) === 1
    })

    console.log(22222222222)
    console.log(this.goodsPackageList)
    this.visible = true
  }

  getAllGoodsPackage () {
    return this.goodsPackageList.map(item => item.packageName)
  }

  // 转换套餐名称
  transformPackage (val: string) {
    if (!val) return ''
    let arr = val.split(',')
    arr = arr.map((item, index) => {
      let data = this.goodsSpecificationList[index].specValueList.filter(items => {
        return item === items.attrValueCode
      })
      return data ? (data[0] ? data[0].attrValue : '') : ''
    })
    return arr.join(',')
  }

  // afterRead (file: FileDTO, index: number) {
  //   const formData = new FormData()
  //   formData.append('fileStream', file.file)
  //   formData.append('fileType', fileTypes.goodsBanner)
  //   upFile(formData).then((res) => {
  //     const file = res.data
  //     this.goodsPackageList[index].mainImageUrl = file.filePath
  //     this.goodsPackageList[index].mainImageBase64 = downloadUrl(file.filePath),
  //     this.goodsPackageList[index].mainImageSize = Number(file.fileSize)
  //     this.goodsPackageList[index].custonMainImg = true
  //   })
  // }

  afterRead (index: number) {
    const data = {
      companyId: this.companyId,
      // 上传文件类别 1公司log 2商品轮播图 3商品推荐图 4商品视频 5商品内容HTML文件 6订单附件
      fileType: fileTypes.goodsBanner,
    }
    this.$bridge.callHandler('uploadFile', data, (res) => {
      const data = !res ? {} : JSON.parse(res)
      // let nameArr = data.filePath.split('/')
      // this.orderInfo.orderFileName = nameArr.pop()
      console.log(this.goodsPackageList[index])

      this.goodsPackageList[index].mainImageUrl = data.filePath
      this.goodsPackageList[index].mainImageBase64 = downloadUrl(data.filePath),
        this.goodsPackageList[index].mainImageSize = Number(data.fileSize)
      this.goodsPackageList[index].custonMainImg = true
      this.goodsImageList = [
        {
          imageUrl: this.goodsPackageList[index].mainImageUrl
        }
      ]
    })
// const  data = {
//       fileType:'1',
//       maxFileCount:'7'
//     }
//     chooseFile(data).then((res:any)=> {
//       this.goodsImageList = res.map((item:{[x:string]:any}) => {
//         return {
//         serialNumber: item.serialNumber,
//         imageUrl: item.filePath,
//         imageBase64Url: downloadUrl(item.filePath),
//         imageSize: item.fileSize
//         }
//       })
      
//     })
  }

  deleteImage (index: number) {
    this.goodsPackageList[index].mainImageUrl = ''
    this.goodsPackageList[index].mainImageBase64 = ''
    this.goodsPackageList[index].custonMainImg = false
  }

  /**
   * 是否上架回调
   */
  handleUpChange (data: goodsPackageDto) {
    if (data.packageStatus === 1) {
      if (this.upGoodsPackageLength <= 1) {
        this.$toast('请至少上架一个套餐')
        return false
      }
      this.upGoodsPackageLength -= 1
    } else if (data.packageStatus === 0) {
      this.upGoodsPackageLength += 1
    }
    data.packageStatus = data.packageStatus ? 0 : 1
  }

  handleIsSyncOtherChange (item, index) {
    item.isSyncOther = item.isSyncOtherBool ? '1' : '0'
    this.$set(this.goodsPackageList,index,item)
  }

  /**
   * 市场价调整回调
   */
  marketPriceChange () {
    if (this.goodsPackageList[0].cusLevelPriceList) {
      this.goodsPackageList[0].cusLevelPriceList.forEach((item, index: number) => {
        const orderPrice = printFn(Number(this.goodsPackageList[0].marketPrice || 0) * Number(item.buyDiscount || 0) / 100)
        this.$set(this.goodsPackageList[0].cusLevelPriceList![index], 'orderPrice', orderPrice)
      })
    }
    if (this.goodsPackageList[0].cusPriceList) {
      this.goodsPackageList[0].cusPriceList!.forEach(item => {
        item.orderPrice = Number(this.goodsPackageList[0].marketPrice) || 0
      })
    }
  }

  /**
   * 按客户级别定价
   */
  setCoomdsPrice () {
    this.$eventBus.$emit('currentPage', 6)
    this.$refs.coomdsPrice.showModal({
      data: JSON.parse(JSON.stringify(this.goodsPackageList[0].cusLevelPriceList)),
      marketPrice: this.goodsPackageList[0].marketPrice
    })
  }

  /**
   * 按客户级别定价回调
   */
  handleSaveCoomdsPrice (data: customerLevelDto[]) {
    this.$set(this.goodsPackageList[0], 'cusLevelPriceList', data)
  }

  /**
   * 按客户定价
   */
  setCustomerPrice () {
    this.$eventBus.$emit('currentPage', 7)
    this.$refs.coomdsPrices.showModal({
      data: JSON.parse(JSON.stringify(this.goodsPackageList[0].cusPriceList)),
      marketPrice: this.goodsPackageList[0].marketPrice,
      isUseCusPrice: this.goodsPackageList[0].isUseCusPrice
    })
  }

  /**
   * 按客户定价回调
   */
  saveCustomerPrice (res: { data: customerPriceDto[], isUseCusPrice: number }) {
    this.$set(this.goodsPackageList[0], 'cusPriceList', res.data)
    this.goodsPackageList[0].isUseCusPrice = res.isUseCusPrice
  }
}
